import { withCompInfo } from '@wix/editor-elements-integrations'
import { getShapeDividersCSSVars } from '../../core/carmi/ShapeDividers/ShapeDividers.mapper'
import type { CompDesign } from '../../core/carmi/ShapeDividers/ShapeDividers.utils'
import { getCompDesignPerVariant } from '../../core/carmi/ShapeDividers/ShapeDividers.utils'
import { getFillLayersCSSVars } from '../../core/mappers/FillLayers/FillLayers.utils'
import type { ClassicSectionCss, ClassicSectionDefinition } from './ClassicSection'

export const css = withCompInfo<ClassicSectionCss, ClassicSectionDefinition>()(
	[
		'compDesign',
		'compProps',
		'experiments',
		'isMobileView',
		'siteColors',
		'viewMode',
		'hasResponsiveLayout',
		'compId',
		// @ts-ignore - Remove once siteWidth is added to the compInfo
		'siteWidth',
		// @ts-ignore - Remove once animations is added to the compInfo
		'animations',
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		'isNonAdaptiveMobile',
	],
	({
		compDesign,
		compProps,
		experiments,
		isMobileView,
		siteColors,
		viewMode,
		hasResponsiveLayout,
		compId,
		// @ts-ignore - Remove once animations is added to the compInfo
		animations,
		// @ts-ignore - Remove once siteWidth is added to the compInfo
		siteWidth,
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		isNonAdaptiveMobile,
	}) => {
		const compDesignPerVariantMap = getCompDesignPerVariant(compDesign)
		const defaultDesign = compDesignPerVariantMap[''] as CompDesign
		const backgroundMedia = defaultDesign?.background || {}

		return {
			...getShapeDividersCSSVars({
				compId,
				hasResponsiveLayout,
				isMobileView,
				compDesignPerVariantMap,
				colorsMap: siteColors,
			}),
			...getFillLayersCSSVars({
				animations,
				backgroundMedia,
				compDesign,
				compProps,
				compId,
				experiments,
				isMobileView,
				isNonAdaptiveMobile,
				siteColors,
				viewMode,
			}),
			'min-width': `${siteWidth}px`,
		}
	}
)
